'use strict';

const { SHOW_ALL_CLASS, HIDDEN_CLASS } = require('../constants');
const { queryFirst, addClass, hasClass, removeClass } = require('../domUtil');
const { destroySwiper, initCarouselElement, CLASS_CAROUSEL_INITIALIZED, SELECTOR_CAROUSEL_WRAPPER, SELECTOR_CLASS_SELECTOR_CAROUSEL } = require('../components/swiperCarousel').default;

const videoComponentEl = queryFirst('.video-component');
const toggleButton = queryFirst('.view-all-carousel');
const printQuickViewSheet = queryFirst('#shop-by-print-quickview');

toggleButton?.addEventListener('click', ev => {
    const carouselWrapper = ev.target.closest(SELECTOR_CAROUSEL_WRAPPER);
    const carouselEl = queryFirst(SELECTOR_CLASS_SELECTOR_CAROUSEL, carouselWrapper);
    if (hasClass(carouselEl, CLASS_CAROUSEL_INITIALIZED)) {
        destroySwiper(carouselEl);
        addClass(carouselWrapper, SHOW_ALL_CLASS);
    } else {
        initCarouselElement(carouselEl);
        removeClass(carouselWrapper, SHOW_ALL_CLASS);
    }
});

module.exports = () => {
    if (videoComponentEl) {
        videoComponentEl.style.opacity = 1;
    }

    if (!printQuickViewSheet) {
        return;
    }

    const quickviewContainer = queryFirst('.js-shop-by-print-quickview-content', printQuickViewSheet);
    const quickviewFooter = queryFirst('.js-shop-by-print-quickview-footer', printQuickViewSheet);

    $(printQuickViewSheet).on('show.bs.modal', e => {
        const { relatedTarget } = e;
        if (!relatedTarget || !quickviewContainer) {
            return;
        }

        const opener = relatedTarget.closest('.shop-by-print-drawer-tile') || relatedTarget;
        const { actionUrl } = opener.dataset;
        if (!actionUrl) {
            return;
        }

        const $spinner = $(printQuickViewSheet).find('.sheet-dialog').spinner();
        $spinner.start();

        $.getJSON(actionUrl, data => {
            quickviewContainer.innerHTML = data.renderedTemplate;

            const footerContent = queryFirst('.js-print-quickview-footer', quickviewContainer);
            if (footerContent && quickviewFooter) {
                quickviewFooter.appendChild(footerContent);
            }

            quickviewContainer.dispatchEvent(new CustomEvent('modalContentLoaded', { bubbles: true }));
        }).always(() => {
            $spinner.stop();
        });
    });

    $(printQuickViewSheet).on('hidden.bs.modal', () => {
        if (quickviewContainer) {
            quickviewContainer.innerHTML = '';
        }
        if (quickviewFooter) {
            quickviewFooter.innerHTML = '';
        }
    });
};
